import { Form, FormSettingsEnum, FormSubtypeEnum } from '@dev/ee-api/ee-api-models'
import { isEmpty, isNil, isString } from 'lodash-es';
import { StepsValidity } from '../types';
import { decodeFormMetaData } from './decodeFormMetaData';
export const getStepsValidity = (formObject: Form): StepsValidity => {
    const metaData = decodeFormMetaData(formObject?.MetaData);
    const isStepNameValid = !!formObject?.Name;
    const isStepDesignValid = !!formObject?.FormTemplateName;
    const isStepSettingsValid = !!formObject?.FormSettings?.includes(FormSettingsEnum.DoubleOptInDisabled) || !!formObject?.FormSettings?.includes(FormSettingsEnum.AddDoubleOptIn);
    const isStepNotificationsValid = (!!formObject?.FormSettings?.includes(FormSettingsEnum.NotifyEmails) && !!formObject?.EmailsToNotifyOnAction) || (!formObject?.FormSettings?.includes(FormSettingsEnum.NotifyEmails) && isEmpty(formObject?.EmailsToNotifyOnAction) && isString(formObject?.EmailsToNotifyOnAction));
    const isStepBehaviourValid = !!formObject && (formObject?.FormSubtype !== FormSubtypeEnum.Popup || (!isNil(metaData?.data?.popupTrigger) && !isNil(metaData?.data?.popupDelay)));
    const isStepPublishValid = isStepNameValid && isStepDesignValid && isStepSettingsValid && isStepNotificationsValid && isStepBehaviourValid;

    return {
        name: isStepNameValid,
        design: isStepDesignValid,
        settings: isStepSettingsValid,
        notifications: isStepNotificationsValid,
        behaviour: isStepBehaviourValid,
        publish: isStepPublishValid,
    };
};
